import { useTranslation } from '@nextgen-web-framework/all';
import styles from './shopfinder.module.scss';
import ShopOptionRadioCard from './ShopOptionRadioCard';
import { IShopsOptions, ShopLayoutProps } from './types/propsTypes';

const ShopListLayout = ({
  setSelectedShop,
  availableShops,
  shopLocations,
  selectedShop,
  shopDetails,
  isLocationAccessAllowed,
}: ShopLayoutProps) => {
  const translate = useTranslation();

  return (
    <>
      <div className={styles['shop-list-heading']}>
        {translate(isLocationAccessAllowed ? 'web.shopFinder.shopsNearYou' : 'web.shopFinder.availableShops')}{' '}
        {`(${availableShops})`}
      </div>
      <div className={styles['shop-list']} id="scrollableShopListContainer">
        {shopLocations?.map((shop: IShopsOptions) => (
          <div key={shop.id} id={shop.id}>
            <ShopOptionRadioCard
              cardData={shop}
              isSelected={selectedShop === shop?.id}
              setSelectedShop={setSelectedShop}
              shopDetails={(data) => shopDetails(data)}
            />
          </div>
        ))}
      </div>
    </>
  );
};

export default ShopListLayout;
